import { render, staticRenderFns } from "./EnterFreeWishes.vue?vue&type=template&id=1afba279&scoped=true"
import script from "./EnterFreeWishes.vue?vue&type=script&lang=js"
export * from "./EnterFreeWishes.vue?vue&type=script&lang=js"
import style0 from "./EnterFreeWishes.vue?vue&type=style&index=0&id=1afba279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afba279",
  null
  
)

export default component.exports